import axios from 'axios';
import { RANDOM_NUMBER } from './utilities';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { isPublicAuthUrl } from './security/password-reset-utils';

const isPublicAuthRequest = (error) => {
  const requestUrl = error?.config?.url || '';
  return isPublicAuthUrl(requestUrl);
};
//intercepter middleware
axios.interceptors.request.use(
(request) => {
      // Add authorization header
      const user_token = Cookies.get('User_Accesstoken');
      if(user_token){
        request.headers['Authorization'] = `Bearer ${user_token}`;
      }
      // Check if request body is FormData
      if (request.data instanceof FormData) {
        request.headers['Content-Type'] = 'multipart/form-data';
      } else {
        request.headers['Content-Type'] = 'application/json';
      }
      return request;
  },
  (error) => {
    // return Promise.reject(error);
    return Promise.resolve({ data: [] });
  }
);
// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (!error.response) {
//       // Network Error
//       toast.error('Network Error, please reload and retry',{
//         toastId:RANDOM_NUMBER
//       });
//     } else {
//       // API Error
//       const { status, data } = error.response;
//       if (status === 500) {
//         toast.error('Internal Server Error, please reload and retry',{
//           toastId:RANDOM_NUMBER
//         });
//       } else {
//         toast.error(data.message || 'Something went wrong, please reload and retry',{
//           toastId:RANDOM_NUMBER
//         });
//       }
//     }
//     // return Promise.reject(error);
//     return Promise.resolve({ data: [] });
//   }
// );

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const publicAuthRequest = isPublicAuthRequest(error);
    if (!error.response) {
      // Covers CORS errors + no internet + server down
      if (error.message === 'Network Error') {
        toast.error('Unable to reach server. Please try again.', {
          toastId: RANDOM_NUMBER
        });
      } else {
        toast.error('Network Error, please reload and retry', {
          toastId: RANDOM_NUMBER
        });
      }
    } else {
      const { status, data } = error.response;

      if (status === 401 && !publicAuthRequest) {
        Cookies.remove('User_Accesstoken');
        window.location.href = '/adminlogin';
      } else if (status === 401) {
        toast.error(data?.message || 'This link or verification has expired. Please try again.', {
          toastId: RANDOM_NUMBER
        });
      } else if (status === 500) {
        toast.error('Internal Server Error, please reload and retry', {
          toastId: RANDOM_NUMBER
        });
      } else {
        toast.error(data?.message || 'Something went wrong, please reload and retry', {
          toastId: RANDOM_NUMBER
        });
      }
    }

    if (publicAuthRequest) {
      return Promise.reject(error);
    }
    return Promise.resolve({ data: {} });
  }
);


export default axios;
